import { render, staticRenderFns } from "./PersAdd.vue?vue&type=template&id=5d786cea&scoped=true"
import script from "./PersAdd.vue?vue&type=script&lang=js"
export * from "./PersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d786cea",
  null
  
)

export default component.exports